import styled from 'styled-components';
import { cvBreakpoint768 } from '@carvana/theme';
import { AlertTriangle } from '@carvana/icons';
import { CarvanaButtonNoCaps } from '@carvana/purchase-styles';


const modalIcon = `
  & > svg {
    transform: scale(2.2);
  }
`;

export const AlertIcon = styled(AlertTriangle)`
  ${modalIcon}

  & > svg > g {
    fill: ${props => props.theme.carvana.yellow.primary};
  }
`;

export const BodyText = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
  max-width: 375px;
  text-align: center;
`;

export const BoldText = styled.p`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
  margin-top: 24px;
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;

  @media (min-width: ${cvBreakpoint768}px) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const CancelButton = styled(CarvanaButtonNoCaps)``;

export const ConfirmButton = styled(CarvanaButtonNoCaps).attrs({
  ghost: true,
})`
  margin-bottom: 14px;

  @media (min-width: ${cvBreakpoint768}px) {
    margin-bottom: 0;
    margin-right: 14px;
  }
`;

export const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 100px 30px 50px;
  position: relative;

  @media (min-width: ${cvBreakpoint768}px) {
    padding-top: 50px;
  }
`;
